module.exports = __webpack_public_path__ + "assets/hoppa0.jpg?5a879aafc21e71357dfc0059ee9cdee5";